<template>
  <div>
    <!-- Loading -->
    <loading v-model:active="isLoading" :is-full-page="true" color="#0A1AA8" />

    <Header2 />

    <div class="rg-c">
      <div class="gc-x">
        <!-- ================= TAB NAV ================= -->
        <TabNav
          :tabs="['NEW GLO PLAN', 'ADD NEW PLAN']"
          :selected="selected"
          @selected="setSelected"
        >
          <!-- ================= LIST GLO PLANS ================= -->
          <Tab :isSelected="selected === 'NEW GLO PLAN'">
            <h2 class="hc-x">GLO DATA PLANS</h2>

            <div v-if="plans.length === 0" class="empty">No plans available</div>

            <div v-for="item in plans" :key="item.plan" class="plan-card">
              <div class="plan-info">
                <strong>{{ item.name }}</strong>
                <span class="badge">₦{{ item.price }}</span>
                <small>Plan Code: {{ item.plan }}</small>
              </div>

              <div class="plan-actions">
                <button class="edit-btn" @click="openEditModal(item)">Edit</button>
                <button class="delete-btn" @click="deletePlan(item.id)">Delete</button>
              </div>
            </div>
          </Tab>

          <!-- ================= ADD NEW PLAN ================= -->
          <Tab :isSelected="selected === 'ADD NEW PLAN'">
            <h2 class="hc-x">ADD NEW GLO PLAN</h2>

            <form @submit.prevent="addPlan">
              <div class="ml-xf">
                <label>Plan Code</label>
                <input class="inp-value" v-model="form.plan" required />
              </div>

              <div class="ml-xf">
                <label>Price</label>
                <input type="number" class="inp-value" v-model="form.price" required />
              </div>

              <div class="ml-xf">
                <label>Plan Name</label>
                <input class="inp-value" v-model="form.name" required />
              </div>

              <div class="ml-xf checkbox">
                <input type="checkbox" v-model="enableGift" />
                <span>Enable Hot Plan</span>
              </div>

              <!-- HOT PLAN -->
              <div v-if="enableGift" class="gift-box">
                <div class="ml-xf">
                  <label>Start Date & Time</label>
                  <input type="datetime-local" class="inp-value" v-model="form.start" />
                </div>

                <div class="ml-xf">
                  <label>End Date & Time</label>
                  <input type="datetime-local" class="inp-value" v-model="form.end" />
                </div>

                <div class="ml-xf">
                  <label>Link Existing Plan</label>
                  <select class="inp-value" v-model="form.link_plan">
                    <option value="">Select Plan</option>
                    <option v-for="p in plans" :key="p.plan" :value="p.plan">
                      {{ p.name }}
                    </option>
                  </select>
                </div>

                <div class="ml-xf">
                  <label>Count</label>
                  <input type="number" class="inp-value" v-model="form.count" />
                </div>
              </div>

              <div class="ml-xf">
                <button :disabled="isDisabled">{{ btnText }}</button>
              </div>
            </form>
          </Tab>
        </TabNav>
      </div>
    </div>

    <!-- ================= EDIT MODAL ================= -->
    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal">
        <h2>Edit Plan</h2>

        <form @submit.prevent="updatePlan">
          <div class="ml-xf">
            <label>Plan Code</label>
            <input class="inp-value" v-model="editForm.plan" required />
          </div>

          <div class="ml-xf">
            <label>Price</label>
            <input type="number" class="inp-value" v-model="editForm.price" required />
          </div>

          <div class="ml-xf">
            <label>Plan Name</label>
            <input class="inp-value" v-model="editForm.name" required />
          </div>

          <div class="ml-xf checkbox">
            <input type="checkbox" v-model="editEnableGift" />
            <span>Enable Hot Plan</span>
          </div>

          <div v-if="editEnableGift" class="gift-box">
            <div class="ml-xf">
              <label>Start Date & Time</label>
              <input type="datetime-local" class="inp-value" v-model="editForm.start" />
            </div>

            <div class="ml-xf">
              <label>End Date & Time</label>
              <input type="datetime-local" class="inp-value" v-model="editForm.end" />
            </div>

            <div class="ml-xf">
              <label>Link Existing Plan</label>
              <select class="inp-value" v-model="editForm.link_plan">
                <option value="">Select Plan</option>
                <option v-for="p in plans" :key="p.plan" :value="p.plan">
                  {{ p.name }}
                </option>
              </select>
            </div>

            <div class="ml-xf">
              <label>Count</label>
              <input type="number" class="inp-value" v-model="editForm.count" />
            </div>
          </div>

          <div class="ml-xf button-row">
            <button type="submit" :disabled="isDisabled" class="btn-primary">
              {{ btnText }}
            </button>
            <button type="button" @click="closeEditModal" class="btn-cancel">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header2 from "../../components/header.vue";
import TabNav from "../../components/tabnav.vue";
import Tab from "../../components/tab.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "GloPlanManager",
  components: { Header2, TabNav, Tab, Loading },

  data() {
    return {
      selected: "NEW GLO PLAN",
      plans: [],
      enableGift: false,
      editEnableGift: false,
      isLoading: true,
      isDisabled: false,
      btnText: "Save",
      token: "",
      showEditModal: false,

      form: {
        plan: "",
        price: "",
        name: "",
        start: "",
        end: "",
        gift_name: "",
        count: "",
        link_plan: "",
      },

      editForm: {
        id: "",
        plan: "",
        price: "",
        name: "",
        start: "",
        end: "",
        gift_name: "",
        count: "",
        link_plan: "",
      },
    };
  },

  watch: {
    "form.link_plan"(val) {
      const found = this.plans.find((p) => p.plan === val);
      this.form.gift_name = found ? found.name : "";
    },
    "editForm.link_plan"(val) {
      const found = this.plans.find((p) => p.plan === val);
      this.editForm.gift_name = found ? found.name : "";
    },
  },

  async mounted() {
    const admin = JSON.parse(localStorage.getItem("admin"));
    this.token = admin?.token || "";
    await this.fetchPlans();
    this.isLoading = false;
  },

  methods: {
    setSelected(tab) {
      this.selected = tab;
    },

    formatDateTime(val) {
      if (!val) return "";
      return new Date(val).toISOString().slice(0, 16);
    },

    async fetchPlans() {
      const res = await axios.get("https://api.tapit.ng/api/glo/getplan", {
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      });
      this.plans = res.data.data || [];
    },

    async addPlan() {
      this.isDisabled = true;
      this.btnText = "Saving...";

      await axios.post(
        "https://api.tapit.ng/api/glo/addplan",
        {
          ...this.form,
          isHot: "1",
          start: this.enableGift ? this.form.start : "",
          end: this.enableGift ? this.form.end : "",
        },
        { headers: { Authorization: `Bearer ${this.token}` } }
      );

      this.resetForm();
      this.fetchPlans();
      this.selected = "NEW GLO PLAN";
    },

    async deletePlan(id) {
      if (!confirm("Delete this plan?")) return;
      await axios.delete(`https://api.tapit.ng/api/glo/${id}`, {
        headers: { Authorization: `Bearer ${this.token}` },
      });
      this.fetchPlans();
    },

    openEditModal(plan) {
      this.showEditModal = true;
      this.editForm = {
        id: plan.id,
        plan: plan.plan,
        price: plan.price,
        name: plan.name,
        start: this.formatDateTime(plan.start),
        end: this.formatDateTime(plan.end),
        gift_name: plan.gift_name || "",
        count: plan.count || "",
        link_plan: plan.link_plan || "",
      };
      this.editEnableGift = !!plan.start || !!plan.end;
      this.btnText = "Update";
    },

    closeEditModal() {
      this.showEditModal = false;
      this.btnText = "Save";
    },

    async updatePlan() {
      this.isDisabled = true;
      this.btnText = "Updating...";

      await axios.post(
        "https://api.tapit.ng/api/glo/addplan",
        {
          ...this.editForm,
          isHot: "1",
          start: this.editEnableGift ? this.editForm.start : "",
          end: this.editEnableGift ? this.editForm.end : "",
        },
        { headers: { Authorization: `Bearer ${this.token}` } }
      );

      this.closeEditModal();
      this.fetchPlans();
      this.isDisabled = false;
    },

    resetForm() {
      this.form = {
        plan: "",
        price: "",
        name: "",
        start: "",
        end: "",
        gift_name: "",
        count: "",
        link_plan: "",
      };
      this.enableGift = false;
      this.isDisabled = false;
      this.btnText = "Save";
    },
  },
};
</script>

<style scoped>
.rg-c {
  padding: 15px;
}
.gc-x {
  max-width: 720px;
  margin: auto;
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  margin-top: 100px;
}
.hc-x {
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 15px;
  padding: 15px;
}
.plan-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
  background: #f8f9ff;
  margin-bottom: 10px;
}
.plan-info {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.badge {
  background: #0a1aa8;
  color: #fff;
  padding: 3px 8px;
  border-radius: 8px;
  font-size: 0.7rem;
  width: fit-content;
}
.delete-btn {
  background: #e53935;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  width: fit-content;
}
.edit-btn {
  background: #0a84ff;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
}
.plan-actions {
  display: flex;
  gap: 8px;
}
.inp-value {
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.button-row {
  display: flex;
  gap: 10px;
  justify-content: flex-end; /* buttons aligned to the right */
}

.btn-primary {
  background: #0a1aa8;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  flex: 1; /* makes button take equal space */
}

.btn-cancel {
  background: #ccc;
  color: #333;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  flex: 1; /* same width as primary button */
}

.checkbox {
  display: flex;
  gap: 8px;
  align-items: center;
}
.gift-box {
  background: #f1f3ff;
  border-radius: 12px;
  padding: 10px;
}
button {
  width: 100%;
  padding: 10px;
  background: #0a1aa8;
  color: #fff;
  border-radius: 10px;
  border: none;
}
.ml-xf {
  margin-bottom: 12px;
}
.empty {
  text-align: center;
  color: #999;
}

/* ================= MODAL ================= */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.modal {
  background: #fff;
  padding: 20px;
  border-radius: 16px;
  max-width: 500px;
  width: 100%;
}
.modal h2 {
  margin-bottom: 15px;
}
.modal button {
  margin-top: 10px;
}
</style>
